import { useTranslation } from 'react-i18next'

import { getScoreBackgroundColor } from '@/ui'

type Props = {
	percentage: number
	isDisqualified?: boolean
}

export function ScoreBadge({ percentage, isDisqualified }: Props) {
	const { t } = useTranslation('common')

	if (isDisqualified) {
		return (
			<span className="px-2.5 py-1 text-sm font-medium rounded-full bg-red-600 text-white">
				{t('candidateCard.disqualification.title')} ({Math.round(percentage)}%)
			</span>
		)
	}

	return (
		<span
			className="px-2.5 py-1 text-sm font-medium rounded-full"
			style={{ backgroundColor: getScoreBackgroundColor(percentage) }}
		>
			{Math.round(percentage)}%
		</span>
	)
}
